'use client';

import { Button } from '@/components/ui/button';
import { useNotifications } from '@/hooks/useNotifications';
import { Bell } from 'lucide-react';

interface SimpleNotificationButtonProps {
  onTokenReceived?: (token: string) => void;
}

export default function SimpleNotificationButton({ onTokenReceived }: SimpleNotificationButtonProps) {
  const { permission, isLoading, requestPermission } = useNotifications();

  if (permission === 'granted') {
    return null; // Não mostra nada se já estiver ativo
  }

  if (permission === 'denied') {
    return null; // Não mostra nada se estiver bloqueado
  }

  const handleClick = async () => {
    const token = await requestPermission();
    if (token && onTokenReceived) {
      onTokenReceived(token);
    }
  };

  return (
    <Button onClick={handleClick} disabled={isLoading} variant='outline' className='gap-2' isLoading={isLoading}>
      <Bell className='h-4 w-4' />
      {isLoading ? 'Ativando...' : 'Ativar Notificações'}
    </Button>
  );
}
